import {pushEvent} from "tracking/core/dispatcher";
import type {OutboundPayload, DownloadPayload, PushOptions} from "../core/types";

/**
 * Pushes an outbound link tracking event via the central dispatcher.
 */
export function dataLayerOutbound(
    domain: string | null | undefined,
    linkId: string | null | undefined,
    linkUrl: string | null | undefined,
    options?: PushOptions
) {
    const payload: OutboundPayload = {
        domain: domain ?? undefined,
        link_id: linkId ?? undefined,
        link_url: linkUrl ?? undefined,
    };

    return pushEvent('outbound', payload, options);
}

/**
 * Pushes a download link tracking event via the central dispatcher.
 */
export function dataLayerDownload(
    contentLabel: string | null | undefined,
    url: string | null | undefined,
    type?: string | null | undefined
) {
    const payload: DownloadPayload = {
        content_label: contentLabel ?? undefined,
        type: type ?? undefined,
        url: url ?? undefined,
    };

    return pushEvent('download', payload);
}

/**
 * Pushes an email click event via the central dispatcher.
 */
export function dataLayerEmail(
    address: string | null | undefined,
    options?: PushOptions
) {
    const payload: { address?: string } = {
        address: address ?? undefined,
    };

    return pushEvent('email', payload, options);
}

/**
 * Pushes a phone call click event via the central dispatcher.
 */
export function dataLayerCallNumber(
    phoneNumber: string | null | undefined,
    options?: PushOptions
) {
    const payload: { phone_number?: string } = {
        phone_number: phoneNumber ?? undefined,
    };

    return pushEvent('call_number', payload, options);
}
